export default "__VITE_ASSET__1k$jya7R__"